import { ShapeOptions } from '@mui/system/createTheme/shape';

const shape: ShapeOptions = {
    borderRadius: 12,
};

export default shape;
